export const HERO_DATA = {
	name: "Rodrigo Lopes",
	tagline: "From Hypothesis to Impact.",
	subtext:
		"Senior Product Manager de-risking innovation through continuous discovery, data-driven experimentation, and emerging-technology-powered build–measure–learn loops.",
	contact: {
		email: "contact@rodrigolopes.xyz",
		linkedin: "linkedin.com/in/rodecalo",
		github: "github.com/r0l0pes",
		web: "rodrigolopes.xyz",
		location: "Berlin, DE",
	},
};
